<template>
	<div ref="viewEditorWrapper">
		<div class="font-weight-medium">Sorting folder</div>
		<v-form ref="form" @submit.prevent="saveFolderToFirestore">
			<v-text-field
				class="mx-3 mt-6"
				label="Name"
				v-model="docData.name"
				:rules="agile.fieldRules.nameRules"
				outlined
				dense
			></v-text-field>
			<v-btn class="ml-3 mb-3" @click="saveFolderToFirestore">
				Save
			</v-btn>
		</v-form>
	</div>
</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from "@/shift/agile";
import fb from '@/shift/fb';


export default
{
    name: 'ViewsEditorTabItemFolder',

	props:
	{
		id: { type: String },
		name: { type: String },
		docData: { type: Object },
		documentType: { type: String },
	},
	
    data: () =>
    ({
		label: '',
		allowFirestoreSave: true,
    }),

    computed:
	{
        agile()
        {
            return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		},
	},

	created()
	{
		this.label = this.name;
	},

    mounted()
    {
        // Save document when pressing "Ctrl+S"
        document.addEventListener("keydown", this.onKeyPresSave);
    },

    methods:
    {

		onKeyPresSave(e)
		{
			if (!(e.keyCode === 83 && e.ctrlKey))
			{
				return;
			}

			// Make sure we are only saving this tabs document.
			// This code below checks if the component is wrapped in an element with display: none; or not
			// Not foolproof though: https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom

			if (this.$refs.viewEditorWrapper.offsetParent)
			{
				this.saveFolderToFirestore();
			}
			
			e.preventDefault();
			
		},



		saveFolderToFirestore()
		{
			//console.log(this.documentType); fb;
			if (this.$refs.form.validate())
			{
				if (this.allowFirestoreSave)
				{
					this.allowFirestoreSave = false;
					
					let doc;

					if (this.documentType === 'sorting-folder-shared-content')
					{
						doc = fb.db
							.collection('content-collection')
							.doc('content-doc')
							.collection(this.routeKey)
							.doc(this.routeKey)
							.collection('shared-content-sorting-folders')
							.doc(this.id);
					}
					else
					{
						doc = fb.db
							.collection('dev-collection')
							.doc('dev-doc')
							.collection(this.routeKey)
							.doc(this.routeKey)
							.collection('views-editor-sorting-folders')
							.doc(this.id);
					}

					doc.update( { name: this.docData.name } )
					.then(() =>
					{
						//console.log("Updated sorting folder label", this.label);
					})
					.catch((error) =>
					{
						console.log('Error updating sorting folder label:', error.message);
					});


					// Protection against spamming firestore, i.e. if the user keeps holding Ctrl+S down
					const scopeThis = this;
					
					setTimeout(function()
					{
						scopeThis.allowFirestoreSave = true;
					}, 1000);
				}
			}
		},
	},
	



	
	beforeDestroy()
	{
		document.removeEventListener("keydown", this.onKeyPresSave);
	},

}

</script>
